import { ChangeDetectionStrategy, Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface IframeDialogData {
  url: string;
	backgroundColor: string;
}

@Component({
  selector: 'app-iframe-dialog',
  templateUrl: './iframe-dialog.component.html',
  styleUrls: ['./iframe-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IframeDialogComponent implements OnInit {
  @ViewChild('modalContents', { static: true })
  modalContents: ElementRef<HTMLDivElement>;

  url: SafeResourceUrl;

  constructor(
    private dialogRef: MatDialogRef<IframeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: IframeDialogData,
    private sanitizer: DomSanitizer,
		private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.url = this.data.url ? this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url) : '';

    this.initFrameListener();

		this.renderer.setStyle(this.modalContents.nativeElement, 'background-color', this.data.backgroundColor || '#ffffff');
  }

  initFrameListener() {
    window.addEventListener('message', (event) => {
      const data = event.data;
      
      if (data.plan && data.action) {
        this.dialogRef.close(data);
      }
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
